import React, { useState, useEffect } from "react";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable';
import '../components/Common.css';
import * as XLSX from 'xlsx';
const PlanVSActualReport = () => {

    const empcode = localStorage.getItem('empcode');
    const { setLoading } = useLoading();

    const [plants, setPlants] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [showSaveButton, setShowSaveButton] = useState(false);

    const [filters, setFilters] = useState({
        CompanyName: "",
        PlantName: "",
        MonthYear: ""
    });

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [plantRes, companyRes] = await Promise.all([
                EmployeeProcessService.getPlant(empcode),
                EmployeeProcessService.getCompany("User"),
            ]);

            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompanies(companyRes.data.result);

        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    // --------------------- Load Plan -------------------------
    const loadPlanData = async () => {
        if (!filters.PlantName || !filters.MonthYear) {
            alert("Please select  Plant and Month.");
            return;
        }

        setLoading(true);
        try {
            const res = await EmployeeProcessService.getPlanReport(
                filters.PlantName,
                filters.MonthYear
            );
            debugger;
            if (res?.data?.statusCode === 200) {

                const data = res.data.result.map(d => ({
                    departmentID: d.departmentID,
                    departmentName: d.departmentName,
                    mpPlan: d.mpPlan ?? 0,
                    // sAbove: d.sAbove,
                    // uptoA: d.uptoA,
                    // apprentice: d.apprentice,
                    // contractual: d.contractual,
                    actual: d.total,
                    gap: d.gap
                }));

                setDepartmentList(data);
                setShowSaveButton(true);
            }

        } catch (err) {
            console.error("Error loading plan:", err);
        } finally {
            setLoading(false);
        }
    };

    // // --------------------- Update Table Values ------------------
    // const updateMPPlan = (index, value) => {
    //     const updated = [...departmentList];
    //     updated[index].mpPlan = value;
    //     setDepartmentList(updated);
    // };

    // // --------------------- Save Plan ----------------------------
    // const savePlan = async () => {

    //     const payload = {
    //         plantID: parseInt(filters.PlantName),
    //         monthYear: filters.MonthYear,
    //         planData: departmentList.map(d => ({
    //             departmentID: parseInt(d.departmentID),
    //             mpPlan: parseInt(d.mpPlan || 0)
    //         }))
    //     };

    //     setLoading(true);
    //     const res = await EmployeeProcessService.setPlan(payload);
    //     setLoading(false);

    //     if (res.success) {
    //         alert("Plan saved successfully!");
    //     } else {
    //         alert("Failed to save plan!");
    //     }
    // };
    const downloadExcel = () => {
        const worksheetData = departmentList.map(d => ({
            //  departmentID: d.departmentID,
            departmentName: d.departmentName,
            mpPlan: d.mpPlan ?? 0,
            // sAbove: d.sAbove,
            // uptoA: d.uptoA,
            // apprentice: d.apprentice,
            // contractual: d.contractual,
            actual: d.actual,
            gap: d.gap
        }));

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");

        XLSX.writeFile(workbook, "PlanVSActualReport.xlsx"); // This downloads the file
    };
    return (
        <div className="container mt-3">

            <h4 className="text-primary mb-3">Plan VS Actual</h4>

            <div className="row mb-3">

                <div className="col-md-3">
                    <label className="text-primary">Plant</label>
                    <select
                        className="form-select"
                        name="PlantName"
                        value={filters.PlantName}
                        onChange={handleChange}
                    >
                        <option value="">Select Plant</option>
                        {plants.map(p =>
                            <option key={p.id} value={p.id}>{p.name}</option>
                        )}
                    </select>
                </div>

                <div className="col-md-3">
                    <label className="text-primary">Month / Year</label>
                    <input
                        type="month"
                        className="form-control"
                        name="MonthYear"
                        value={filters.MonthYear}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-3 mt-4">
                    <button className="btn btn-primary" onClick={loadPlanData}>
                        Submit
                    </button>

                </div>

                <div className="col-md-3 mt-4">
                    {departmentList.length > 0 && (
                        <button className="btn btn-success filter-btn" onClick={downloadExcel}>Download Excel</button>
                    )}
                </div>

            </div>

            {/* TABLE */}
            {departmentList.length > 0 && (
                <>
                    {departmentList && (
                        <div className="table-responsive">
                            <CustomDataTable data={departmentList} title="Employee List" />
                        </div>
                    )}
                </>
            )}

        </div>
    );
};

export default PlanVSActualReport;
